<script lang="ts">
	import { yyyy, zzzz } from "../../store.svelte";
	import { toast } from "../../lib/toast.svelte.ts";
	import { onMount } from "svelte";


	interface Props {
		lw_id: number;
		status: string;
		phase: string;
		iama: string;
		clkd: string;
		table: string;
	}

	let { lw_id, status, phase, clkd, iama, table }: Props = $props();

	const url: string = yyyy.uri.api;

	let FindingEnergized: boolean = $state(false);
	let noBelow: boolean = $state(false);
	let noAbove: boolean = $state(false);
	let noPhaseA: boolean = $state(false);
	let noPhaseB: boolean = $state(false);
	let noPhaseC: boolean = $state(false);
	let direction: string = $state("Below");
	let anyorall: string = $state("Any");
	let phases = $state({ A: [false, true], B: [false, true], C: [false, true] });

	if (status === "LOAD") {
		noBelow = !noBelow;
		direction = "Above";
	}
	if (status === "SOURCE") {
		noAbove = !noAbove;
	}
	let linordev: string = "Lines";

	for (let char of phase) {
		if (char in phases) {
			phases[char] = [true, false];
		}
	}

	let handleAnyOrAll = (event) => {
		anyorall = event.target.textContent;
	};
	let handleDirection = (event) => {
		direction = event.target.textContent;
	};

	let handleLinesOrDevices = (event) => {
		linordev = event.target.textContent;
	};
	let handlePhase = (event) => {
		phases[event.target.textContent][0] = !phases[event.target.textContent][0];
		if (!phases.A[0] && !phases.B[0] && !phases.C[0]) {
			alert("At least one phase must be selected");
			phases[event.target.textContent][0] = !phases[event.target.textContent][0];
		}
	};

	type energizedItem = {
		lw_id: number;
		phase: string;
		status: string;
		lw_table: string;
		lw_table_pkid: string;
	};

	let findEnergized = async () => {
		FindingEnergized = !FindingEnergized;
		let phasequery = "";
		let geomout;
		for (let key in phases) {
			if (phases[key][0]) {
				phasequery = phasequery + key;
			}
		}
		if (anyorall === "Any") {
			phasequery = phasequery + "*";
		}
		if (anyorall === "All") {
			phasequery = phasequery + "=";
		}
		if (linordev === "Lines") {
			geomout = "EDGE";
		}
		if (linordev === "Devices") {
			geomout = "NODE";
		}

		let _bodyprep = {
			direction: direction.toUpperCase(),
			lw_phase: phasequery,
			lw: yyyy.sesh.activeLivewire.wireident,
		};
		if (iama === "EDGE") {
			_bodyprep.lat = clkd.lat;
			_bodyprep.lng = clkd.lng;
			_bodyprep.tablename = table;
		}

		if (iama === "NODE") {
			_bodyprep.lw_id = lw_id;
		}

		let _body = JSON.stringify(_bodyprep);

		let _hdrs = {
			"Content-Type": "application/json",
			Authorization: "Bearer " + yyyy.sesh.logtoken.token,
		};
		let fetchopts = { method: "post", body: _body, headers: _hdrs };
		const response = await fetch(`${url}/rpc/findenergized`, fetchopts);
		if (response.ok) {
			let nrgzd = await response.json();
			console.log("nrgzd: ", nrgzd);
			if (nrgzd.findenergized.features == null) {

				toast.warning("No devices on the selected phase");
				FindingEnergized = !FindingEnergized;
				return;
			}
			//yyyy.map.idnt = nrgzd.findenergized.features
			//yyyy.map.nrgzd = nrgzd.findenergized;
			zzzz.emit("foundEnergized", nrgzd);
			yyyy.nrgzd = nrgzd;
		} else {
			toast.error(
				"There was an error, please try again. If this persists, give us a call"
			);
			FindingEnergized = !FindingEnergized;
			return;
		}
	};

	onMount(() => {
		console.log('------------')
		console.log(lw_id)
		console.log(iama)

		console.log('------------')
	})

</script>
<div class="energized-content">
	<div class="button-group">
		<button
			class="option-button wide"
			class:active={direction === "Above"}
			disabled={noAbove}
			onclick={handleDirection}
		>
			Above
		</button>
		<button
			class="option-button wide"
			class:active={direction === "Below"}
			disabled={noBelow}
			onclick={handleDirection}
		>
			Below
		</button>
	</div>

	<div class="option-row">
		<div class="button-group">
			<button
				class="option-button"
				class:active={anyorall === "Any"}
				onclick={handleAnyOrAll}
			>
				Any
			</button>
			<button
				class="option-button"
				class:active={anyorall === "All"}
				onclick={handleAnyOrAll}
			>
				All
			</button>
		</div>

		<div class="button-group">
			<button
				class="option-button phase"
				onclick={handlePhase}
				disabled={phases.A[1]}
				class:active={phases.A[0]}
			>
				A
			</button>
			<button
				class="option-button phase"
				onclick={handlePhase}
				disabled={phases.B[1]}
				class:active={phases.B[0]}
			>
				B
			</button>
			<button
				class="option-button phase"
				onclick={handlePhase}
				disabled={phases.C[1]}
				class:active={phases.C[0]}
			>
				C
			</button>
		</div>
	</div>

	<button
		class="submit-button"
		class:is-loading={FindingEnergized}
		onclick={findEnergized}
	>
		Find Energized
	</button>
</div>

<style>
	.energized-content {
		padding-bottom: 0.75rem;
		font-size: 0.9rem;
	}

	.button-group {
		display: flex;
		margin-bottom: 0.75rem;
	}

	.option-row {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 0.75rem;
	}

	.option-button {
		flex: 1;
		padding: 0.5rem;
		border: 1px solid #dbdbdb;
		background-color: #fff;
		color: #4a4a4a;
		font-size: 0.9rem;
		cursor: pointer;
		transition: all 0.2s;
	}

	.option-button:first-child {
		border-radius: 4px 0 0 4px;
	}

	.option-button:last-child {
		border-radius: 0 4px 4px 0;
	}

	.option-button:not(:last-child) {
		border-right: none;
	}

	.option-button.wide {
		min-width: 50%;
	}

	.option-button.phase {
		min-width: 40px;
	}

	.option-button:hover:not(:disabled):not(.active) {
		background-color: #f5f5f5;
	}

	.option-button.active {
		background-color: #3273dc;
		color: white;
		border-color: #3273dc;
	}

	.option-button.active:hover:not(:disabled) {
		background-color: #2366d1;
		color: white;
	}

	.option-button:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}

	.submit-button {
		width: 100%;
		padding: 0.5rem 1rem;
		background-color: #3273dc;
		color: white;
		border: none;
		border-radius: 4px;
		font-size: 0.9rem;
		cursor: pointer;
		transition:
			background-color 0.2s,
			opacity 0.2s;
	}

	.submit-button:hover {
		background-color: #2366d1;
	}

	.submit-button.is-loading {
		position: relative;
		color: transparent;
	}

	.submit-button.is-loading::after {
		content: "";
		position: absolute;
		width: 1em;
		height: 1em;
		top: calc(50% - 0.5em);
		left: calc(50% - 0.5em);
		border: 2px solid #ffffff;
		border-right-color: transparent;
		border-radius: 50%;
		animation: spinner 0.5s linear infinite;
	}

	@keyframes spinner {
		from {
			transform: rotate(0deg);
		}
		to {
			transform: rotate(360deg);
		}
	}
</style>
